import { useState } from 'react'

// Of het lezen voor de deelnemer van het rapport mislukt is. Eén plek voor de
// drie lees-hooks van de deelnemerwidgets (usePersonaProfile, usePersonaLadder,
// usePersonaWorkSkills): de fout hoort bij één deelnemer, zodat hij na een
// wissel niet blijft hangen. Zonder deze helper stond dit recept drie keer los.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure

/**
 * @param {string|null} personaId - Uit useWidgetPersona / usePublicPersona
 * @returns {{ failed: boolean, onError: () => void }} `onError` geef je mee aan useFirestoreQuery
 */
const usePersonaReadFailure = (personaId) => {
    const [failedFor, setFailedFor] = useState(/** @type {string|null} */ (null))
    return {
        failed: !!personaId && failedFor === personaId,
        onError: () => setFailedFor(personaId),
    }
}

export default usePersonaReadFailure
